<template>
  <div class="entry-info-team-detail">
    <!-- 年度注册类型：先展示年度注册球队信息（编辑状态下隐藏） -->
    <div v-if="project.publicSignUp === 2 && (orgTeamDetail || displayTeamForOrg) && !isEditing" class="org-team-block">
      <div class="selected-team-info">
        <div class="logo">
          <img v-if="displayTeamForOrg.badge" :src="imageView(displayTeamForOrg.badge)" alt="">
          <img v-else src="@/assets/default-icon.png" alt="">
        </div>
        <div class="info">
          <div class="name">{{ displayTeamForOrg.name || '-' }}</div>
          <div class="contact">{{ displayTeamForOrg.contactPerson || '-' }}</div>
          <div class="phone">{{ displayTeamForOrg.contactNumber || '-' }}</div>
        </div>
      </div>
    </div>
    <!-- 赛事组别设置的球队报名信息（年度注册时隐藏基础信息字段；非年度注册时为全部字段） -->
    <div class="team-detail-header">
      <span class="team-detail-title">队伍信息</span>
      <van-button
        v-if="(team.isSubmit === 0 || team.auditStatus === -1) && !isEditing"
        class="team-detail-edit-btn"
        size="small"
        type="primary"
        plain
        @click="goEdit"
      >
        编辑
      </van-button>
    </div>
    <entry-info-team-form
      v-if="inited"
      ref="teamForm"
      title-text="队伍信息"
      :hide-title="true"
      :show-reselect-button="false"
      :show-selected-team-info="false"
      :hidden-fields="project.publicSignUp === 2 ? ['name','contactPerson','contactNumber','badge'] : []"
      :team="team"
      :team-checkboxes="teamCheckboxes"
      :clothes="clothes"
      :team-color="teamColor"
      :team-signup-fields-label="teamSignupFieldsLabel"
      :team-id="teamId"
      :readonly="!isEditing"
      @open-delegation="showDelegation = true"
      @open-home-color="showHomeColor = true"
      @open-away-color="showAwayColor = true"
      @upload-badge="uploadBadge"
      @delete-badge="deleteBadge"
      @upload-file="uploadFile"
      @delete-file="deleteFile"
      @preview-clothes="previewImg"
      @choose-clothes="chooseClothes"
    />
    <!-- 编辑状态下显示底部保存按钮（查看状态隐藏） -->
    <div class="bottom-actions" v-if="(team.isSubmit === 0 || team.auditStatus === -1) && isEditing">
      <van-button class="bottom-btn" type="info" @click="saveTeam"
        :style="{ 'background-color': jetlympic ? '#00A7FF' : '#509DEA' }">保 存</van-button>
    </div>
    <van-popup v-model="showDelegation" position="bottom" :style="{ height: '50%' }">
      <van-picker title="代表团" show-toolbar :columns="delegationList" @confirm="onConfirmDelegation"
        @cancel="showDelegation = false" />
    </van-popup>
    <van-popup v-model="showHomeColor" position="bottom" :style="{ height: '50%' }">
      <van-picker title="请选择主队服颜色" show-toolbar :columns="clothesColor" @confirm="onConfirmHomeColor"
        @cancel="showHomeColor = false">
        <template #option="option">
          <div style="display: flex; align-items: center">
            <img :src="option.img" style="width: 24px; height: 24px; margin-right: 12px" />
            <span>{{ option.label }}</span>
          </div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showAwayColor" position="bottom" :style="{ height: '50%' }">
      <van-picker title="请选择客队服颜色" show-toolbar :columns="clothesColor" @confirm="onConfirmAwayColor"
        @cancel="showAwayColor = false">
        <template #option="option">
          <div style="display: flex; align-items: center">
            <img :src="option.img" style="width: 24px; height: 24px; margin-right: 12px" />
            <span>{{ option.label }}</span>
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { Toast, ImagePreview, Popup } from 'vant'
import { getBMMatchTeamSignup, getBMUnionMatch, getOrgTeamDetail, updateBMMatchTeam } from '@/api/match'
import EntryInfoTeamForm from './entry-info-team-form.vue'
import { QNImageUtil } from '@/utils'
import { getQiniuUploadToken, uploadImage } from '@/api/qiniu'
import Vue from 'vue'
Vue.use(Popup)
Vue.use(Toast)
Vue.use(ImagePreview)
const clothesColor = [
  { value: '1', label: '白色', img: require('../../../assets/jersey-color/qy_1.png') },
  { value: '2', label: '蓝色', img: require('../../../assets/jersey-color/qy_2.png') },
  { value: '3', label: '暗红', img: require('../../../assets/jersey-color/qy_3.png') },
  { value: '4', label: '深黄', img: require('../../../assets/jersey-color/qy_4.png') },
  { value: '5', label: '绿色', img: require('../../../assets/jersey-color/qy_5.png') },
  { value: '6', label: '紫色', img: require('../../../assets/jersey-color/qy_6.png') },
  { value: '7', label: '橙色', img: require('../../../assets/jersey-color/qy_7.png') },
  { value: '8', label: '黑色', img: require('../../../assets/jersey-color/qy_8.png') },
  { value: '9', label: '白底黑条纹', img: require('../../../assets/jersey-color/qy_9.png') },
  { value: '10', label: '紫底黑条纹', img: require('../../../assets/jersey-color/qy_10.png') },
  { value: '11', label: '白底红条纹', img: require('../../../assets/jersey-color/qy_11.png') },
  { value: '12', label: '红底黑条纹', img: require('../../../assets/jersey-color/qy_12.png') },
  { value: '13', label: '黄底红条纹', img: require('../../../assets/jersey-color/qy_13.png') },
  { value: '14', label: '红底紫条纹', img: require('../../../assets/jersey-color/qy_14.png') },
  { value: '15', label: '白底蓝条纹', img: require('../../../assets/jersey-color/qy_15.png') },
  { value: '16', label: '黄底绿条纹', img: require('../../../assets/jersey-color/qy_16.png') },
  { value: '17', label: '白底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_17.png') },
  { value: '18', label: '白底红条纹（竖）', img: require('../../../assets/jersey-color/qy_18.png') },
  { value: '19', label: '白底黄条纹（竖）', img: require('../../../assets/jersey-color/qy_19.png') },
  { value: '20', label: '白底蓝条纹（竖）', img: require('../../../assets/jersey-color/qy_20.png') },
  { value: '21', label: '红底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_21.png') },
  { value: '22', label: '红底紫条纹（竖）', img: require('../../../assets/jersey-color/qy_22.png') },
  { value: '23', label: '黄底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_23.png') },
  { value: '24', label: '黄底绿条纹（竖）', img: require('../../../assets/jersey-color/qy_24.png') },
  { value: '25', label: '粉红', img: require('../../../assets/jersey-color/qy_25.png') },
  { value: '26', label: '天蓝', img: require('../../../assets/jersey-color/qy_26.png') },
  { value: '27', label: '浅黄', img: require('../../../assets/jersey-color/qy_27.png') }
]

const defaultTeamColor = () => ({
  home: { a: '', b: '', c: '', d: '', e: '', f: '', g: '' },
  away: { a: '', b: '', c: '', d: '', e: '', f: '', g: '' }
})

export default {
  name: 'EntryInfoTeamDetail',
  components: { EntryInfoTeamForm },
  data() {
    return {
      project: {},
      match: {},
      team: {},
      teamCheckboxes: {},
      teamSignupFieldsLabel: { insurancePolicy: '参赛资料' },
      clothes: [],
      teamColor: defaultTeamColor(),
      projectId: '',
      unionMatchId: '',
      teamId: '',
      orgTeamDetail: null,
      inited: false,
      jetlympic: false,
      isEditing: false,
      showDelegation: false,
      showHomeColor: false,
      showAwayColor: false,
      delegationList: [],
      qiniuToken: '',
      clothesColor
    }
  },
  computed: {
    /** 年度注册时用于展示“年度注册球队信息”的数据：优先机构详情，否则用当前队伍 */
    displayTeamForOrg() {
      if (this.orgTeamDetail) {
        return {
          name: this.orgTeamDetail.name ?? this.orgTeamDetail.teamName ?? '-',
          contactPerson: this.orgTeamDetail.contactPerson ?? '-',
          contactNumber: this.orgTeamDetail.contactNumber ?? '-',
          badge: this.orgTeamDetail.badge ?? this.orgTeamDetail.logo ?? ''
        }
      }
      if (this.project.publicSignUp === 2 && this.team) {
        return {
          name: this.team.name ?? '-',
          contactPerson: this.team.contactPerson ?? '-',
          contactNumber: this.team.contactNumber ?? '-',
          badge: this.team.badge ?? ''
        }
      }
      return null
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) this.jetlympic = true
    this.unionMatchId = this.$route.query.unionMatchId
    this.projectId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    this.loadMatch()
  },
  methods: {
    loadMatch() {
      getBMUnionMatch({ unionMatchId: this.unionMatchId }).then(res => {
        if (res && res.data) this.match = res.data.match || {}
        this.fetchSignup()
      }).catch(() => this.fetchSignup())
    },
    fetchSignup() {
      const params = { matchId: this.projectId }
      if (this.teamId) params.teamId = this.teamId
      getBMMatchTeamSignup(params).then(res => {
        if (!res || !res.data) return
        const data = res.data
        const project = data.match || {}
        this.project = project
        if (project.teamSignupFieldsLabel) {
          this.teamSignupFieldsLabel = { ...this.teamSignupFieldsLabel, ...project.teamSignupFieldsLabel }
        }
        this.delegationList = (project.teamDelegations && project.teamDelegations.split(',')) || []
        this.clothes = data.clothes || []
        const tsfs = (project.teamSignupFields && project.teamSignupFields.split('|')) || []
        const teamCheckboxes = {}
        tsfs.forEach(tsf => { teamCheckboxes[tsf] = true })
        this.teamCheckboxes = teamCheckboxes
        if (data.team) {
          this.team = data.team
          this.team.badgeList = this.team.badge ? [{ url: this.imageView(this.team.badge), isImage: true }] : []
          this.team.homeClothesColorImg = this.findImg(this.team.homeClothesColor)
          this.team.awayClothesColorImg = this.findImg(this.team.awayClothesColor)
          if (this.team.insurancePolicy) {
            this.team.insurancePolicyList = [{ url: this.imageView(this.team.insurancePolicy), isImage: false }]
          }
          this.parseClothesColorDescription(this.team.clothesColorDescription)
        }
        if (project.publicSignUp === 2 && this.team.orgTeamId) {
          this.fetchOrgTeamDetail(this.team.orgTeamId)
        }
        this.inited = true
      })
    },
    fetchOrgTeamDetail(orgTeamId) {
      if (!orgTeamId) return
      getOrgTeamDetail(orgTeamId).then(res => {
        const d = res && (res.data || res)
        this.orgTeamDetail = d || null
      }).catch(() => { this.orgTeamDetail = null })
    },
    parseClothesColorDescription(str) {
      if (!str || typeof str !== 'string') return
      const labelToKey = {
        '主场上衣': ['home', 'a'], '主场短裤': ['home', 'b'], '主场球袜': ['home', 'c'],
        '主场守门员上衣': ['home', 'd'], '主场守门员短裤': ['home', 'e'], '主场守门员球袜': ['home', 'f'], '主场替补背心': ['home', 'g'],
        '客场上衣': ['away', 'a'], '客场短裤': ['away', 'b'], '客场球袜': ['away', 'c'],
        '客场守门员上衣': ['away', 'd'], '客场守门员短裤': ['away', 'e'], '客场守门员球袜': ['away', 'f'], '客场替补背心': ['away', 'g']
      }
      str.split(',').forEach(part => {
        const idx = part.indexOf(':')
        if (idx === -1) return
        const label = part.slice(0, idx).trim()
        const value = part.slice(idx + 1).trim()
        const pair = labelToKey[label]
        if (pair && value) {
          const [side, key] = pair
          this.$set(this.teamColor[side], key, value)
        }
      })
    },
    findImg(colorIndex) {
      const c = clothesColor.find(item => item.value === colorIndex)
      return c ? c.img : ''
    },
    imageView(img) {
      return img ? QNImageUtil.imageView(img) : ''
    },
    goEdit() {
      this.isEditing = true
      this.getQiniuUploadToken()
    },
    saveTeam() {
      const formRef = this.$refs.teamForm
      if (!formRef || !formRef.validate) return
      formRef.validate().then(() => {
        const params = JSON.parse(JSON.stringify(this.team))
        delete params.badgeList
        delete params.homeClothesColorImg
        delete params.awayClothesColorImg
        delete params.insurancePolicyList
        if (this.teamCheckboxes.clothesColorDescription) {
          const home = this.teamColor.home
          const away = this.teamColor.away
          params.clothesColorDescription = `主场上衣:${home.a},主场短裤:${home.b},主场球袜:${home.c},客场上衣:${away.a},客场短裤:${away.b},客场球袜:${away.c},主场守门员上衣:${home.d},主场守门员短裤:${home.e},主场守门员球袜:${home.f},主场替补背心:${home.g},客场守门员上衣:${away.d},客场守门员短裤:${away.e},客场守门员球袜:${away.f},客场替补背心:${away.g}`
        }
        params.matchId = this.projectId
        params.id = this.teamId
        updateBMMatchTeam(params).then(res => {
          if (res) {
            Toast.success('保存成功')
            this.isEditing = false
            this.fetchSignup()
          }
        })
      })
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    onConfirmDelegation(e) {
      this.team.delegation = e
      this.showDelegation = false
    },
    onConfirmHomeColor(value) {
      this.$set(this.team, 'homeClothesColor', value.value)
      this.$set(this.team, 'homeClothesColorImg', value.img)
      this.showHomeColor = false
    },
    onConfirmAwayColor(value) {
      this.$set(this.team, 'awayClothesColor', value.value)
      this.$set(this.team, 'awayClothesColorImg', value.img)
      this.showAwayColor = false
    },
    uploadBadge(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.$set(this.team, 'badge', res.hash)
        this.$forceUpdate()
      })
    },
    uploadFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      const type = file.file.type.split('/')[1]
      uploadImage(formData).then(res => {
        this.team.insurancePolicy = res.hash + ',' + type
        this.team.insurancePolicyList = [{ url: this.imageView(this.team.insurancePolicy), isImage: false }]
        this.$forceUpdate()
      })
    },
    deleteBadge() {
      this.$set(this.team, 'badge', '')
      this.$set(this.team, 'badgeList', [])
    },
    deleteFile() {
      this.$set(this.team, 'insurancePolicy', '')
      this.$set(this.team, 'insurancePolicyList', [])
    },
    chooseClothes(item) {
      if (item.isChoosed === 1) return
      this.$set(this.team, 'clothesId', item.id)
    },
    previewImg(img) {
      if (!img) return
      ImagePreview([this.imageView(this.getClothesImg(img))])
    },
    getClothesImg(id) {
      const c = this.clothes.find(item => item.id === id)
      return c ? c.image : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-info-team-detail {
  min-height: 100vh;
  background-color: #f6f6f8;
  padding-bottom: 80px;
}

.team-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  height: 50px;
  box-sizing: border-box;
  .team-detail-title {
    font-size: 15px;
    font-weight: 500;
    color: #1d2129;
  }
  .team-detail-edit-btn {
    width: 68px;
    height: 30px;
    padding: 0;
    font-size: 13px;
    color: var(--bg3);
    background-color: #E9E9EB;
    border: none;
  }
}
.title-info {
  padding: 16px;
  background: #fff;
  margin-bottom: 12px;
  .h1 {
    font-size: 18px;
    color: #1d2129;
    font-weight: 500;
  }
  .h2 {
    font-size: 14px;
    color: #666;
    margin-top: 6px;
  }
}
.org-team-block {
  background: #fff;
  padding: 12px 16px;
  .block-title {
    font-size: 15px;
    color: #1d2129;
    font-weight: 500;
    margin-bottom: 12px;
  }
}
.selected-team-info {
  display: flex;
  align-items: center;
  .logo {
    width: 60px;
    height: 60px;
    border-radius: 5px;
    background: #d8d8d8;
    overflow: hidden;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .info {
    margin-left: 16px;
    flex: 1;
    min-width: 0;
    .name {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
    .contact, .phone {
      font-size: 12px;
      color: #666;
      margin-top: 5px;
    }
  }
}
.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
  display: flex;
  justify-content: flex-end;
  .bottom-btn {
    width: 132px;
    height: 50px;
    border: none;
    color: #FFFFFF;
    border-radius: 25px;
  }
}
::v-deep .van-field__label{
  color: rgba(0, 0, 0, 0.9);
}
::v-deep .van-field__control{
  font-weight: 500;
}
::v-deep .van-uploader{
  width: 100% !important;
}
::v-deep .van-uploader__wrapper{
  display: block;
}
</style>
